import { DataGrid } from '@mui/x-data-grid'
import React from 'react'

function DataGridTable(props) {
    return (
        <DataGrid
            rows={props.rowData}
            columns={props.columns}
            // getRowId={(row) => props.page === "subscription" ? row.id : row.activity_id}
            getRowId={(row) => row.id}
            hideFooter
            disableRowSelectionOnClick
            paginationMode="server"
            columnHeaderHeight={55}
            rowHeight={58}
            className="subscription-data-grid"
            getRowClassName={(params) =>
                params.row?.isSkeleton ? "skeleton-row" : ""
            }
            sx={{
                border: 0,
                backgroundColor: "#fff",
                borderRadius: "12px",
                height: props.height,

                "& .MuiDataGrid-columnHeaders": {
                    background: "#ffffff",
                    borderBottom: "none",
                },

                "& .MuiDataGrid-columnHeader": {
                    color: "#2563EB", // Blue header text
                    fontWeight: 700,
                    fontSize: "13px",
                },

                "& .MuiDataGrid-columnHeaderTitle": {
                    color: "#2563EB",
                    fontWeight: 800,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    fontSize: "12px",
                },

                "& .MuiDataGrid-columnSeparator": {
                    display: "none",
                },

                "& .MuiDataGrid-row": {
                    borderBottom: "1px solid #eef2f7",
                    // transition: "0.25s",
                },

                "& .MuiDataGrid-row:nth-of-type(even)": {
                    backgroundColor: "#fbfcfe",
                },

                "& .MuiDataGrid-row:hover": {
                    backgroundColor: "#eef5ff",
                },

                "& .MuiDataGrid-cell": {
                    border: "none",
                    color: "#374151",
                    fontSize: "14px",
                },

                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": {
                    outline: "none",
                },
            }}
        />
    )
}

export default DataGridTable
